import { GTooltip } from 'components/basic-blocks'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { GNewToggle } from 'components/basic-blocks/g-new-toggle/g-new-toggle'
import { Platform, AccountSelectionState } from './types'

interface PlatformTogglesProps {
	platform: Platform
	accountSelection: AccountSelectionState
	onChange: (updates: Partial<AccountSelectionState>) => void
}

export const PlatformToggles = ({
	platform,
	accountSelection,
	onChange
}: PlatformTogglesProps) => {
	// GADS + BADS: tracking toggle removed — replaced by the tracking confirmation UI
	if (platform === 'GADS' || platform === 'BADS') {
		return null
	}

	if (platform === 'FADS') {
		return (
			<div className="flex gap-2 items-center">
				<GNewToggle
					labelClassName="text-t-checkbox-unactive text-[16px] font-normal"
					checked={accountSelection.set_custom_audience}
					onChange={(c) => onChange({ set_custom_audience: c })}
					label="Automatically set excluded audience in ad sets"
				/>
				<GTooltip
					content="Updates targeting on ad sets to exclude ClickGuard's audience of blocked users"
					position="top"
					arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
					contentClassName="border-none mb-2 bg-t-smoke font-medium text-sm text-t-desc-gray"
				>
					<AiOutlineQuestionCircle className="text-t-gray-hold w-4 h-4" />
				</GTooltip>
			</div>
		)
	}

	// Default: no platform-specific toggles
	return null
}
